import { GlobalWorkerOptions } from "pdfjs-dist";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.js";

// Tell PDF.js where the worker file is
GlobalWorkerOptions.workerSrc = workerSrc;
